/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
 */
export interface QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount {
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'accountType': QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'companyName': string;
}

export const QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum = typeof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum];


